import { createLoadable } from '@main/core-ui';

// Load the component dynamically
export const PrivacyCenterRoutes = createLoadable({
  loader: () => import('./index'),
});
